import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* updatePassword({ data, callbacks }) {
  try {
    yield call(api.updatePassword, data);
    yield put(Actions.updatePasswordSuccess());
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success);
    }
  } catch (error) {
    yield put(Actions.updatePasswordFail(error));
    if (typeof callbacks?.failure === 'function') {
      const err = error?.response?.data?.error;
      yield call(callbacks.failure, Array.isArray(err) ? err[0] : err);
    }
  }
}

function* watchUpdatePassword() {
  yield takeLatest(Actions.UPDATE_PASSWORD_REQUEST, updatePassword);
}

export default function* update() {
  yield all([fork(watchUpdatePassword)]);
}
